import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, IconButton } from '@mui/material';
import { Close, CloseFullscreen, Fullscreen } from '@mui/icons-material';

interface DialogBaseProps extends React.PropsWithChildren {
    open: boolean;
    onClose: (data?: any) => void;
    title: React.ReactNode;
    showCloseButton?: boolean;
    minWidth?: string | number;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    fullWidth?: boolean;
    buttonLabel?: string;
    onButtonClick?: () => void;
    dialogActions?: React.ReactNode;
    fullScreen?: boolean;
    showFullScreenButton?: boolean;
    onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
    marginTop?: string;
}

const DialogBase: React.FC<DialogBaseProps> = ({ open, onClose, title, children, showCloseButton, minWidth, fullWidth, buttonLabel, onButtonClick, dialogActions, fullScreen, showFullScreenButton, onKeyDown, marginTop }) => {
    const [fullScreenLocal, setFullScreenLocal] = React.useState(false);

    useEffect(() => {
        setFullScreenLocal(fullScreen ?? false);
    }, [fullScreen]);

    return (
        <Dialog fullWidth={fullWidth} PaperProps={{ sx: { minWidth: minWidth } }} open={open} onClose={onClose} fullScreen={fullScreenLocal} disablePortal maxWidth='lg' onKeyDown={onKeyDown} sx={{ marginTop: marginTop }}>
            <DialogTitle>
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography variant='h5'>{title}</Typography>
                    {onButtonClick && <Button variant='outlined' onClick={onButtonClick}>{!buttonLabel ? 'Button' : buttonLabel}</Button>}

                    <div style={{ float: 'right', display: 'flex', alignContent: 'flex-end' }}>
                        <div style={{ marginTop: '-14px' }}>
                            {showFullScreenButton && <IconButton onClick={() => { setFullScreenLocal(!fullScreenLocal) }} >
                                {fullScreen ? <CloseFullscreen /> : <Fullscreen />}
                            </IconButton>}
                            {showCloseButton && <IconButton onClick={() => onClose()}><Close /></IconButton>}
                        </div>
                    </div>
                </Box>
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            {dialogActions && <DialogActions>
                {dialogActions}
            </DialogActions>}
        </Dialog>
    );
};

export default DialogBase;